import { ConstraintSpec } from '../../process/capability-spec/constraints/constraint-spec'
import { PropertySpec } from '../spec/property-spec'

export class DynamicPropertySpec {
  public id: string

  public name: string

  public conditions: ConstraintSpec[] = []

  public properties: PropertySpec[] = []
}
